// Escolha de um post já publicado no Facebook ou no Instagram para usar como criativo na Meta.
import { Check } from 'lucide-react'
import type { MetaPostRef } from '@impulso/shared/api/builder'
import { errorMessage } from '../../lib/api'
import { useMetaPosts } from './api'

export default function MetaPostPicker({ companyId, value, onChange }: { companyId: string; value: MetaPostRef | null | undefined; onChange: (post: MetaPostRef | null) => void }) {
  const q = useMetaPosts(companyId)
  const items = q.data?.items ?? []
  return (
    <div className="stack" style={{ gap: 8 }}>
      {q.isLoading && <div className="row" style={{ gap: 10 }}>{[0, 1, 2].map((i) => <div key={i} className="skeleton thumb" style={{ width: 96, height: 96 }} />)}</div>}
      {q.isError && <div className="form-error">{errorMessage(q.error)} <button type="button" className="btn ghost sm" onClick={() => q.refetch()}>Tentar de novo</button></div>}
      <div className="row wrap" style={{ gap: 10 }}>
        {items.map((p) => {
          const on = value?.id === p.id
          const label = `${p.source === 'instagram' ? 'Instagram' : 'Facebook'}: ${p.text?.slice(0, 80) || 'post sem texto'}`
          return (
            <button key={p.id} type="button" className="thumb" title={label} aria-label={label} aria-pressed={on}
              onClick={() => onChange(on ? null : { source: p.source, id: p.id, text: p.text ?? null, imageUrl: p.imageUrl ?? null, permalink: p.permalink ?? null })}
              style={{ position: 'relative', width: 96, height: 96, padding: 0, overflow: 'hidden', border: on ? '3px solid var(--primary)' : '3px solid transparent', background: '#eceef2' }}>
              {p.imageUrl
                ? <img src={p.imageUrl} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                : <span className="small muted" style={{ padding: 6, display: 'block', overflow: 'hidden' }}>{p.text?.slice(0, 60)}</span>}
              <span className="small strong" style={{ position: 'absolute', bottom: 4, left: 4, background: 'rgba(0,0,0,.6)', color: 'white', borderRadius: 6, padding: '1px 6px' }}>{p.source === 'instagram' ? 'IG' : 'FB'}</span>
              {on && <span style={{ position: 'absolute', top: 4, left: 4, background: 'var(--primary)', borderRadius: 999, display: 'grid', placeItems: 'center', width: 20, height: 20 }}><Check size={13} color="white" /></span>}
            </button>
          )
        })}
      </div>
      {q.data?.notes.map((n) => <p key={n} className="small muted">{n}</p>)}
      {q.isSuccess && items.length === 0 && !q.data.notes.length && <p className="small muted">Não encontramos posts recentes na Página nem no Instagram da empresa.</p>}
      <p className="small muted">O anúncio usa o texto e a imagem do post, e mantém as curtidas e os comentários dele.</p>
    </div>
  )
}
